import getOr from "lodash/fp/getOr";

const queryString = require('query-string');

export const removeURLParameter = (url, parameter) => {
  //prefer to use l.search if you have a location/link object
  const urlparts = url.split('?');
  if (urlparts.length >= 2) {

    const prefix = encodeURIComponent(parameter) + '=';
    const pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (let i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

export const changeQueryString = (key, value, url) => {
  if (!url) url = window.location.href;
  if ('URL' in window) {
    const result = new URL(url);
    if (typeof value !== 'undefined' && value !== null) {
      result.searchParams.set(key, value);
    } else {
      result.searchParams.delete(key);
    }
    return result.href;
  } else {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null) {
        return url.replace(re, '$1' + key + "=" + value + '$2$3');
      }
      else {
        hash = url.split('#');
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1];
        }
        return url;
      }
    }
    else {
      if (typeof value !== 'undefined' && value !== null) {
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        hash = url.split('#');
        url = hash[0] + separator + key + '=' + value;
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1];
        }
        return url;
      }
      else {
        return url;
      }
    }
  }
}

export const genHashUrl = (hash = "", url = window.location) => {
  let result = url.origin;
  if (url.pathname !== "/") {
    result += url.pathname;
  }
  if (url.search) {
    result += url.search;
  }
  return result + hash;
}

export const getParamUrl = (name, source) => {
  if (source) {
      return getOr(undefined, `${name}`)(queryString.parse(source));
  }
  return getOr(undefined, `${name}`)(queryString.parse(window.location.search));
}